<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb42></breadcrumb42>

      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar1></sidebar1>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile">
              <h3 class="mb-3">Doctor Review</h3>
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Doctor</label>
                        <v-select
                          class="mr-2"
                          name="practitioner_name"
                          required=""
                          label="practitioner_name"
                          placeholder="select doctor"
                          v-model="testimonials.doctor"
                          :reduce="(option) => option.name"
                          :options="all_doctors"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Video Link</label>
                        <input
                          type="text"
                          v-model="testimonials.video_link"
                          class="form-control"
                          placeholder="Video Link"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label>Rating</label>
                        <v-select
                          class="mr-2"
                          v-model="testimonials.rating"
                          placeholder="select rating"
                          :options="all_rating"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group testimonial">
                        <label>Content</label>
                        <ckeditor
                          :editor="editor"
                          v-model="testimonials.content"
                        ></ckeditor>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button
                      type="submit"
                      @click="Save_Information()"
                      class="btn btn-primary submit-btn"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mapState } from "vuex";
export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      all_treatments: [],
      all_rating: [1, 2, 3, 4, 5],
      all_doctors: [],
      testimonials: {
        patient: this.$store.state.user.user_id,
        treatment: "",
        content: "",
        video_link: "",
        rating: "",
        doctor: "",
      },
      showspinner: true,
      editor: ClassicEditor,
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_testimonial_treatment();
    this.my_doctors_list();
  },
  methods: {
    /* Get Doctors */
    async my_doctors_list() {
      const params = new URLSearchParams();
      params.append("patient", this.user_id);
      await CommonApi.get_data("sahaj.api.my_doctors_list", params).then(
        (res) => {
          this.all_doctors = res.data;
        }
      );
    },

    /* Get Treatment */
    async get_testimonial_treatment() {
      await CommonApi.get_data("sahaj.api.get_testimonial_treatment").then(
        (res) => {
          this.all_treatments = res.message;
        }
      );
    },

    /* Add Testimonial */
    Save_Information() {
      CommonApi.post_data(
        "sahaj.api.add_testimonials",
        JSON.stringify(this.testimonials)
      ).then((res) => {
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.clearform();
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    /* Clear Form */
    clearform() {
      (this.testimonials.treatment = ""),
        (this.testimonials.content = ""),
        (this.testimonials.video_link = ""),
        (this.testimonials.rating = ""),
        (this.testimonials.doctor = "");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/PatientTestimonial.vue